// Reusable brand signature. Casing is deliberate and must never be transformed: "Hi behind Ai".
const SIZES = {
  hero: "text-2xl sm:text-3xl md:text-[2.25rem]",
  section: "text-2xl sm:text-3xl",
  small: "text-xl sm:text-2xl",
};

export default function HiBehindAi({ size = "section", className = "", testid = "hi-behind-ai" }) {
  return (
    <p
      data-testid={testid}
      className={`font-bebas normal-case leading-none tracking-[0.03em] ${SIZES[size] || SIZES.section} ${className}`}
      style={{ textTransform: "none" }}
    >
      <span className="text-[#E50914] font-bold">Hi</span>{" "}
      <span className="text-white font-bold">behind</span>{" "}
      <span className="text-zinc-400">Ai</span>
    </p>
  );
}
